// extracted by mini-css-extract-plugin
export default {"menu":"walletBlock_menu__6vQKC","wallet-dropdown":"walletBlock_wallet-dropdown__gTMjr","total-number":"walletBlock_total-number__vioUI","wallet-img":"walletBlock_wallet-img__qFRNx"};